module.exports = __webpack_public_path__ + "img/lego-key.064faa0d.svg";